module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/dashboard.component.html
// module id = ./src/app/modules/dashboard/dashboard.component.html
// module chunks = main